/** A map on a page, in the designer's panel: its name, its height, its tools, its layers, each with what it shows, and its fences. */
export const mapPart = {
  name: 'Name',
  height: 'Height',
  heights: { small: 'Small', medium: 'Medium', large: 'Large' },
  layers: 'Layers',
  addLayer: 'Add a layer',
  kinds: { place: 'A place', lines: 'A place for each line', route: 'A route', me: 'The reader’s own place', regions: 'Areas by colour', reach: 'The area within some minutes' },
  words: 'Words',
  remove: (label: string) => `Remove the layer ${label}`,
  where: 'Where it is',
  onePoint: (label: string) => `${label}, one point`,
  latLng: 'A latitude and a longitude',
  latitude: 'Latitude',
  longitude: 'Longitude',
  lines: 'Lines',
  pinShows: 'Its pin shows',
  nothing: 'Nothing',
  pinLook: 'Its pin looks like',
  pinLooks: { pin: 'A pin', label: 'Its words', icon: 'An icon', photo: 'A round photo', dot: 'A dot' },
  photo: 'Photo',
  icon: 'Icon',
  turnedBy: 'Turned by, in degrees',
  moves: 'It moves: it glides to each new place',
  follow: 'Keep it in view as it moves',
  staleAfter: 'Seconds before it says when it was last seen',
  cardTitle: 'Its card’s title',
  from: 'From',
  to: 'To',
  through: 'Through the lines of',
  none: 'None',
  mode: 'By',
  modes: { car: 'Car', bike: 'Bike', foot: 'On foot' },
  progress: 'The way travelled fades, and the time left counts down',
  writeSeconds: 'Seconds left go into',
  writeMetres: 'Metres left go into',
  writeLine: 'Its line goes into',
  noPlace: 'No field can hold a place: a JSON field holding a point, or two number fields.',
  noLines: 'No field of lines holds a place for each line.',
  noRoute: 'A route joins two places: add a place first.',
  oneMe: 'The map has the reader’s own place already.',
  noRegions: 'This app gives its maps no areas to shade.',
  noReach: 'A reachable area is worked out from a place: add a place first.',
  toolsName: 'Tools',
  tools: { satellite: 'Satellite', traffic: 'Traffic', fullscreen: 'Full screen', measure: 'Measure a distance' },
  borders: 'Areas',
  knownBy: 'Each known by',
  namedBy: 'Each named by',
  shadedBy: 'Shaded by',
  legend: 'A legend of the shades',
  pressChooses: 'A press chooses it into',
  minutes: 'Minutes',
  fences: 'Fences',
  fencesHint: 'Steps run when a place that moves goes into an area, or comes out of it: in the browser showing the map.',
  addFence: 'Add a fence',
  fenceWatch: 'Watch',
  fenceWhen: 'When it',
  fenceWhens: { enter: 'Goes into', leave: 'Comes out of' },
  fenceArea: 'The area',
  removeFence: (name: string) => `Remove the fence: ${name}`,
  noFenceLayer: 'A fence watches a place that moves: tick “It moves” on a place, or add the reader’s own place.',
  noFenceArea: 'A fence needs an area: a JSON field holding one, or the area within some minutes.',
  fenceSays: (layer: string, area: string) => `${layer} is in ${area}.`,
  note: 'The map itself is drawn in Try it, by the app’s maps.',
};
